export const ACTIONS_MENU_WIDTH = 260;
